const AnyKey = Symbol("Events.AnyKey");

class KeyListeners {
    constructor() {
        this._listeners = new Map();
    }

    listen(name, callback) {
        let listeners = this._listeners.get(name);

        if (!listeners) {
            listeners = new Set();
            this._listeners.set(name, listeners);
        }

        listeners.add(callback);
    }

    unlisten(name, callback) {
        const listeners = this._listeners.get(name);

        if (listeners) {
            listeners.delete(callback);

            if (listeners.size === 0) {
                this._listeners.delete(name);
            }
        }
    }

    fire(name, ...args) {
        const listeners = this._listeners.get(name);

        if (listeners) {
            for (const callback of listeners) {
                callback(...args);
            }
        }
    }

    isEmpty() {
        return this._listeners.size === 0;
    }
}

class Events {
    constructor() {
        this._keyListeners = new Map();
    }

    listen(name, key, callback) {
        let keyListeners = this._keyListeners.get(key);

        if (!keyListeners) {
            keyListeners = new KeyListeners();
            this._keyListeners.set(key, keyListeners);
        }

        keyListeners.listen(name, callback);
    }

    unlisten(name, key, callback) {
        const keyListeners = this._keyListeners.get(key);

        if (keyListeners) {
            keyListeners.unlisten(name, callback);

            if (keyListeners.isEmpty()) {
                this._keyListeners.delete(key);
            }
        }
    }

    _fireOnKey(name, key, ...args) {
        const keyListeners = this._keyListeners.get(key);

        if (keyListeners) {
            keyListeners.fire(name, ...args);
        }
    }

    fire(name, key, ...args) {
        this._fireOnKey(name, key, ...args);
        this._fireOnKey(name, AnyKey, ...args);
    }
}

Events.AnyKey = AnyKey;

export default Events;
export { Events, AnyKey };
